import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.model';
import { Insight } from '../../../../common/models/insight.model';
import { StepTask } from '../../../../common/models/assign-to-me.model';

export type AssignedTasksSort = { key: string; value: 'asc' | 'desc' };

export interface AssignedTasksUiFeatures {
  showResourceTypeFilter: boolean;
  showOnHold: boolean;
  showProjectLink: boolean;
}

export interface AssignedTasksAdapter {
  readonly uiFeatures: AssignedTasksUiFeatures;

  getTasks(
    page: number,
    perPage: number,
    filter: string,
    sort: AssignedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<StepTask>>;

  getInsights(): Observable<{ data: Insight[] }>;

  exportTasks(form: Record<string, unknown>): Observable<unknown>;

  getTaskRouterLink(taskId: number, flowId: number): string[];

  getRelatedRequestViewLink(childFlowId: number): string;
}

export const ASSIGNED_TASKS_ADAPTER = new InjectionToken<AssignedTasksAdapter>(
  'ASSIGNED_TASKS_ADAPTER'
);
